import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { ButtonGroup as ButtonGroup$1, FlexMixin } from '@zillow/constellation';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CustomPropTypes, negativeMarginMixin } from '@zillow/zrs-cms';
import { generateBlockList } from '../../components/BlockList/BlockList.js';

var _excluded = ["margin", "justifyContent", "alignItems", "fluid", "direction"];
var StyleButtonGroup = /*#__PURE__*/styled(ButtonGroup$1).withConfig({
  componentId: "sc-koeb2i-0"
})(["", " ", ""], FlexMixin, negativeMarginMixin);
var BlockButtonGroup = function BlockButtonGroup(_ref) {
  var _ref$attrs = _ref.attrs,
    margin = _ref$attrs.margin,
    _ref$attrs$justifyCon = _ref$attrs.justifyContent,
    justifyContent = _ref$attrs$justifyCon === void 0 ? {
      default: 'flex-start'
    } : _ref$attrs$justifyCon,
    _ref$attrs$alignItems = _ref$attrs.alignItems,
    alignItems = _ref$attrs$alignItems === void 0 ? {
      default: 'flex-start'
    } : _ref$attrs$alignItems,
    _ref$attrs$fluid = _ref$attrs.fluid,
    fluid = _ref$attrs$fluid === void 0 ? {
      default: false
    } : _ref$attrs$fluid,
    _ref$attrs$direction = _ref$attrs.direction,
    direction = _ref$attrs$direction === void 0 ? {
      default: 'row'
    } : _ref$attrs$direction,
    attrs = _objectWithoutProperties(_ref$attrs, _excluded),
    index = _ref.index,
    innerBlocks = _ref.innerBlocks;
  return /*#__PURE__*/React.createElement(StyleButtonGroup, _extends({
    justifyContent: justifyContent,
    alignItems: alignItems,
    fluid: fluid,
    direction: direction
  }, attrs, margin, {
    key: index
  }), generateBlockList({
    blocks: innerBlocks
  }));
};
BlockButtonGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  index: PropTypes.number,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({})),
  attrs: PropTypes.shape({
    direction: CustomPropTypes.inlineMediaQuery(PropTypes.string),
    fluid: CustomPropTypes.inlineMediaQuery(PropTypes.bool),
    conjoined: PropTypes.bool,
    margin: CustomPropTypes.inlineMediaQuery(PropTypes.shape({
      marginTop: PropTypes.string,
      marginBottom: PropTypes.string
    })),
    alignItems: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'baseline'])),
    justifyContent: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly', 'initial', 'inherit']))
  })
} : {};
var ButtonGroup = BlockButtonGroup;

export { ButtonGroup as default };
